import { forwardRef } from 'react';
import { cn } from '../lib/cn';

export const Input = forwardRef(function Input({ className, ...props }, ref) {
  return (
    <input
      ref={ref}
      className={cn(
        'h-10 w-full rounded-md border border-[hsl(var(--border))] bg-[hsl(var(--card))]',
        'px-3 text-sm text-[hsl(var(--fg))] placeholder:text-[hsl(var(--fg-muted))]',
        'focus-ring focus:border-[hsl(var(--border-strong))]',
        'disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
});

export const Textarea = forwardRef(function Textarea({ className, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      className={cn(
        'w-full rounded-md border border-[hsl(var(--border))] bg-[hsl(var(--card))]',
        'px-3 py-2 text-sm text-[hsl(var(--fg))] placeholder:text-[hsl(var(--fg-muted))]',
        'focus-ring focus:border-[hsl(var(--border-strong))]',
        className
      )}
      {...props}
    />
  );
});

export const Label = forwardRef(function Label({ className, ...props }, ref) {
  return (
    <label
      ref={ref}
      className={cn(
        'mb-1 block text-xs uppercase tracking-widest text-[hsl(var(--fg-muted))]',
        className
      )}
      {...props}
    />
  );
});

export const Select = forwardRef(function Select({ className, children, ...props }, ref) {
  return (
    <select
      ref={ref}
      className={cn(
        'h-10 w-full rounded-md border border-[hsl(var(--border))] bg-[hsl(var(--card))]',
        'px-3 text-sm text-[hsl(var(--fg))]',
        'focus-ring focus:border-[hsl(var(--border-strong))]',
        className
      )}
      {...props}
    >
      {children}
    </select>
  );
});
